export default __webpack_public_path__ + "static/ulrich-7c7f9b8b1385e6b641b1b32f06812d4c.png";